import { useState } from "react";
import { Check } from "lucide-react";
import PreviewField from "./PreviewField";
// import { uploadImage as defaultUpload } from "./api";

/**
 * Fillable form (Bootstrap). Builder preview + real customer form, dono.
 * Props: form, onSubmit?(answers), uploadImage?(file)
 */
export default function PreviewForm({ form, onSubmit, uploadImage = "" }) {
  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});
  const [done, setDone] = useState(false);
  const [banner, setBanner] = useState(null);
  const [busy, setBusy] = useState(false);

  const set = (k, v) => setValues((p) => ({ ...p, [k]: v }));

  const submit = async () => {
    setBanner(null);
    const errs = {};
    form.fields.forEach((f) => {
      if (!f.required) return;
      const v = values[f.key];
      const empty =
        v == null || v === "" || (Array.isArray(v) && v.length === 0);
      if (empty) errs[f.key] = "This field is required";
    });
    setErrors(errs);
    if (Object.keys(errs).length) return;

    const answers = {};
    Object.entries(values).forEach(([k, v]) => {
      if (v == null || v === "" || (Array.isArray(v) && v.length === 0)) return;
      answers[k] = v;
    });

    try {
      setBusy(true);
      if (onSubmit) await onSubmit(answers);
      setDone(true);
    } catch (e) {
      if (e.fieldErrors) setErrors(e.fieldErrors);
      setBanner(e.message || "Submission failed");
    } finally {
      setBusy(false);
    }
  };

  if (done) {
    return (
      <div
        className="card shadow-sm mx-auto text-center p-5"
        style={{ maxWidth: 520 }}
      >
        <div
          className="fb-icon bg-success-subtle text-success mx-auto mb-3"
          style={{ width: "3rem", height: "3rem" }}
        >
          <Check />
        </div>
        <h2 className="h5 mb-1">Thank you!</h2>
        <p className="text-secondary mb-3">
          Your customization has been received.
        </p>
        <button
          type="button"
          className="btn btn-link btn-sm"
          onClick={() => {
            setDone(false);
            setValues({});
          }}
        >
          Submit another
        </button>
      </div>
    );
  }

  return (
    <div className="card shadow-sm mx-auto" style={{ maxWidth: 520 }}>
      <div className="card-header bg-white py-3">
        <div
          className="small text-uppercase text-primary fw-semibold"
          style={{ letterSpacing: ".1em" }}
        >
          Customize
        </div>
        <h1 className="h4 mb-0 mt-1">{form.name}</h1>
      </div>
      <div className="card-body p-4">
        {banner && <div className="alert alert-danger py-2">{banner}</div>}
        {form.fields.map((f) => (
          <PreviewField
            key={f.id || f.key}
            field={f}
            value={values[f.key]}
            setValue={(v) => set(f.key, v)}
            error={errors[f.key]}
            uploadImage={uploadImage}
          />
        ))}
        <button
          type="button"
          className="btn btn-primary w-100 py-2"
          onClick={submit}
          disabled={busy}
        >
          {busy ? "Submitting…" : "Submit"}
        </button>
      </div>
    </div>
  );
}
